import React from 'react';
import { motion } from 'framer-motion';
import { Clock, MessageSquare, FileText, CheckSquare } from 'lucide-react';
export function SolutionSection() {
  const elements = [{
    icon: <Clock className="w-6 h-6 text-white" data-id="element-236" />,
    title: 'La Regla del Frío',
    description: 'Nunca negociar en caliente. Se agenda una ventana de 10 minutos cuando el cerebro no está en modo "ataque".'
  }, {
    icon: <MessageSquare className="w-6 h-6 text-white" data-id="element-237" />,
    title: 'Guiones "Cero Drama"',
    description: 'Frases exactas para iniciar temas difíciles sin que la otra persona se ponga a la defensiva.'
  }, {
    icon: <FileText className="w-6 h-6 text-white" data-id="element-238" />,
    title: 'El Contrato de Pared',
    description: 'Plantillas para escribir el acuerdo. Lo que no se escribe, se olvida (y se vuelve a discutir).'
  }, {
    icon: <CheckSquare className="w-6 h-6 text-white" data-id="element-239" />,
    title: 'Cierre Definitivo',
    description: 'Un checklist para asegurar que ambos entendieron lo mismo. Adiós a los malentendidos.'
  }];
  return <section className="py-24 px-4 bg-brown text-cream relative overflow-hidden" data-id="element-240">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-241">
        <div className="absolute top-10 left-10 w-64 h-64 rounded-full bg-terracotta blur-3xl" data-id="element-242"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 rounded-full bg-blush blur-3xl" data-id="element-243"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-244">
        <div className="text-center mb-16" data-id="element-245">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-cream mb-8" data-id="element-246">
            Por qué Acuerdos Express funciona donde la "comunicación" falla
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-cream/90 space-y-6 leading-relaxed max-w-3xl mx-auto mb-12" data-id="element-247">
            <p data-id="element-248">
              La mayoría de las parejas intentan resolver problemas emocionales
              con lógica. Error.
            </p>
            <p data-id="element-249">
              Acuerdos Express no te pide que "hables mejor". Te da una
              estructura rígida que elimina la emoción del proceso de toma de
              decisiones. Es burocracia amorosa. Y funciona.
            </p>
            <p className="italic border-l-2 border-terracotta pl-4 text-cream/70" data-id="element-250">
              Cuando tienes un sistema, no necesitas tener "buena voluntad" todo
              el tiempo. Solo necesitas seguir los pasos.
            </p>
            <p className="font-bold text-xl text-terracotta pt-4" data-id="element-251">
              El sistema reemplaza la fricción con claridad:
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-252">
          {elements.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white/5 backdrop-blur-sm border border-white/10 p-6 rounded-xl hover:bg-white/10 transition-colors flex gap-4" data-id="element-253">
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-terracotta flex items-center justify-center shadow-lg mt-1" data-id="element-254">
                {item.icon}
              </div>
              <div data-id="element-255">
                <h3 className="text-lg font-bold text-cream mb-2" data-id="element-256">
                  {item.title}
                </h3>
                <p className="text-cream/70 leading-relaxed text-sm" data-id="element-257">
                  {item.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="mt-16 text-center" data-id="element-258">
          <p className="text-2xl font-serif italic text-terracotta" data-id="element-259">
            "Saca la improvisación de la ecuación, y verás cómo desaparece el
            conflicto."
          </p>
        </motion.div>
      </div>
    </section>;
}